<template>
  <v-footer
    class="my-3"
    dark
    color="transparent"
    height="auto">
    <v-card
      id="graaa"
      flat
      tile
      style="margin: auto"
      class="px-3 roundedcard white--text text-xs-center elevation-16">
      <v-card-text
        v-if="showResetBtn"
        class="mt-3 white--text pt-0">
        <v-layout 
          row 
          wrap>
          <!-- <v-flex class="text-xs-center">
              <span class="headline">
                Nix los
              </span>
            </v-flex> -->

          <v-flex
            xs12
            class="mt-2 text-xs-center">
            <div class="mt-2 animated jackInTheBox delay-2s"> 
              <v-icon
                size="100">
                fas fa-monkey
              </v-icon>
            </div>
          </v-flex>
        </v-layout>
        <div class="mt-2 animated bounceIn delay-2s">
          <article class="headline font-weight-bold">
            Oh nein!
          </article>
          <article class="headline">
            Der Affe hat all die Posts geklaut!
          </article>
        </div>

        <div class="subheading animated bounceIn delay-3s">
          Mit dieser Filtereinstellung ist hier heute leider nichts los!
        </div>
       
        <div class="subheading animated bounceIn delay-3s">
          <v-btn
            v-if="showResetBtn" 
            ref="button"
            class="mt-3" 
            outline
            @click="clickReset">
            <v-icon
              left>
              far fa-times-octagon
            </v-icon>
            Reset Filter
          </v-btn>
        </div>
      </v-card-text>
      <v-card-text
        v-if="!showResetBtn"
        class="mt-3 white--text pt-0">
        <v-layout 
          row 
          wrap>
          <!-- <v-flex class="text-xs-center">
              <span class="headline">
                Nix los
              </span>
            </v-flex> -->

          <v-flex
            xs12
            class="mt-2 text-xs-center">
            <div class="mt-2 animated jackInTheBox delay-0s"> 
              <v-icon
                size="100">
                fas fa-tree-palm
              </v-icon>
            </div>
          </v-flex>
        </v-layout>
        <div class="mt-2 animated bounceIn delay-1s">
          <article class="headline font-weight-bold">
            Oh Oh!
          </article>
          <article class="headline">
            Du bist auf einer einsamen Insel gestrandet!
          </article>
        </div>

        <div class="subheading animated bounceIn delay-2s">
          Hier ist ja absolut gar nichts los!
        </div>
       
        <div class="subheading animated bounceIn delay-2s">
          <v-btn
           
            ref="button"
            class="mt-3" 
            outline
            @click="clickNewLocation">
            <v-icon
              left>
              far fa-map-marker-alt
            </v-icon>
            Anderen Ort wählen
          
            <v-icon
              right>
              far fa-plane-departure
            </v-icon>
          </v-btn>
        </div>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-text class="white--text">
        &copy;2019 — <strong>WeVent</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    'getAllPosts': { 
      type: Array,
      default: null
    },
    
  },
  data() {
    return{
      showResetBtn: true
    } 
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
    }),
  },
  methods: {
    ...mapActions([
      'resetFilter'
    ]),
    ...mapMutations([
      'setSelectedFilter',
      'clicktimelinedrawer',
    ]),
    clickReset() {
      this.resetFilter()
      this.showResetBtn = false
    },
    clickNewLocation() {
      this.clicktimelinedrawer(true)
      this.setSelectedFilter({ selectedFilter: 'AppFilterLocation', filterText: 'Location' })
    }
  },
  
}
</script>


<style scoped>
#graaa {
  background-image: linear-gradient(330deg, rgba(216,27,96,1), #eeff41);
}

</style>
